type IDatasourceConnectionRequirement = {
  [key in string]: {
    isMulti: boolean;
    title: string;
    learnMoreURL: string;
    requirements?: string[];
  };
};

// test

export const newDatasource = {
  SELECT_DATASOURCE: 'SELECT_DATASOURCE',
  CONNECT_NEW_ACTIVE_CAMPAIGN: 'CONNECT_NEW_ACTIVE_CAMPAIGN',
  CONNECTING_DATASOURCE: 'CONNECTING_DATASOURCE',
  SUCCESS: 'SUCCESS',
};

export const creatingStep = {
  CONNECT: 'Connecting to',
  PROGRESS: 'Connecting to',
  PULL: 'Pulling new data from',
};

export const showGoogleBtn = ['Google Ads', 'YouTube', 'Google Analytics'];

export const datasourceConnectionRequirements: IDatasourceConnectionRequirement = {
  facebook: {
    isMulti: false,
    title: 'Currently we only support facebook pages.',
    learnMoreURL:
      'https://support.viewmetrics.com/en/article/connecting-social-media-pages-i2y4rr/',
  },
  instagram: {
    isMulti: true,
    title: 'Your Instagram profile must be:',
    requirements: ['A business account', 'Connected to a Facebook page'],
    learnMoreURL:
      'https://support.viewmetrics.com/en/article/connecting-your-instagram-account-1cwomcs/',
  },
  linkedin: {
    isMulti: false,
    title: 'Currently we only support LinkedIn pages.',
    learnMoreURL:
      'https://support.viewmetrics.com/en/article/connecting-social-media-pages-i2y4rr/',
  },
};

export const ProviderRename: { [key: string]: string } = {
  linkedin: 'LinkedIn',
};
